
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/svg/[[...slug]]",
      function () {
        return require("private-next-pages/svg/[[...slug]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/svg/[[...slug]]"])
      });
    }
  